"use strict";
/* eslint-disable import/no-unused-modules */
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = exports.Race = exports.Gender = void 0;
var domain_1 = require("./domain");
Object.defineProperty(exports, "Gender", { enumerable: true, get: function () { return domain_1.Gender; } });
Object.defineProperty(exports, "Race", { enumerable: true, get: function () { return domain_1.Race; } });
var generate_1 = require("./generate");
Object.defineProperty(exports, "generate", { enumerable: true, get: function () { return generate_1.generate; } });
//# sourceMappingURL=index.js.map